import { css } from '@emotion/css';

const wrapper = css`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  min-height: 90vh;
  max-width: 650px;
  padding: var(--spacings-1);
  margin: 0 auto;

  a {
    color: var(--colors-primary-500);
    text-decoration: none;
    transition: all 0.2s ease-in-out;

    &:hover {
      color: var(--colors-primary-700);
      text-decoration: underline;
    }
  }
`;

const text = css`
  &.MuiTypography-root {
    margin-top: var(--spacings-2);
    text-align: center;
  }
`;

const boldText = css`
  &.MuiTypography-root {
    font-weight: bold;
  }
`;

const actionButton = css`
  &.MuiButton-root {
    margin-top: var(--spacings-4);
    background-color: var(--colors-primary-500);
    border-radius: var(--radius-2);
    text-transform: none;

    &:hover {
      background-color: var(--colors-primary-700);
    }
  }
`;

const InactiveUserStyles = {
  wrapper,
  text,
  boldText,
  actionButton,
};

export default InactiveUserStyles;
